/*
  Contact Form
*/



class  KozmozAPI{

  

      constructor( app ){
        this.app = app;
        console.log("hostname:",window.location.hostname)
        console.log("debug:",app.config.debug)
        if(app.config.debug == true){
          this.url = window.location.protocol + '//' + window.location.hostname  +  '/';
          // this.url = window.location.protocol + '//' + window.location.hostname +':10024/Alisan.group/';
        }else{
          this.url = window.location.protocol + '//' + window.location.hostname +'/';
          // Prodyction
        }
        console.log("API URL:" ,this.url)
        this.endpoints = { 'subscribe' : this.url + 'subscribe-api' };
        // this._self = this;
        this.init();


      }



      init = () => {
        console.log("KomozAPI.init:",this);
      }


// ----------------------------------------------------------------------------------------
      // API REQUEST
      post ( url,params, callbackLoad, callbackError  ) 	{
                console.log('API.request:',url,params)
                // https://javascript.info/xmlhttprequest
                let xhr = new XMLHttpRequest();
                // xhr.timeout = 40000; // timeout in ms, 40 seconds
                // let queryStr = url + this.formatParams(params);
                // xhr.open('GET', queryStr);
                xhr.open('POST',url);

                xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                xhr.onload   = callbackLoad;
                xhr.onerror  = callbackError;
                // API REQUEST
                let encoded_params = this.paramize(params);
                // console.log('encoded_params:',encoded_params);
                xhr.send(encoded_params);
                // Send Ajax Request
                // xhr.send();

        }

      paramize  = ( object ) => {
        var encodedString = '';
        for (var prop in object) {
            if (object.hasOwnProperty(prop)) {
                if (encodedString.length > 0) {
                    encodedString += '&';
                }
                encodedString += encodeURI(prop + '=' + object[prop]);
            }
        }
        return encodedString;
      }


      formatParams = ( params ) => {
        return "?" + Object
              .keys(params)
              .map(function(key){
                return key+"="+encodeURIComponent(params[key])
              })
              .join("&")
      }


}

export default KozmozAPI
